export const getSeniorConfig = () => {
  return {
    grandPrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1754321820/senior/50k.webp',
        alt: 'VIP Big Game Experience',
        title: 'VIP Big Game Experience',
        value: '$50,000',
      },
    ],
    firstPlacePrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1754321817/senior/10k.webp',
        alt: 'College Football Season Tickets',
        title: 'College Football Season Tickets',
        value: '$10,000',
      },
    ],
    secondPlacePrizes: [
      {
        image:
          'https://images.angelstudios.com/image/upload/v1754072053/senior/cc12f5ca99247c22c65aba1b566c7fafbb3c4553.webp',
        alt: 'Full-Ride Scholarships to Sul Ross State University',
        title: 'Full-Ride Scholarships to Sul Ross State University',
        value: '$113,000',
      },
    ],
    numberOfWinners: {
      firstPlace: 'nine (9)',
    },
  }
}
